import {
    BuildingContactView,
    BuildingView,
    CompanyBuildingView,
    CompanyMarketView,
    CompanyView,
    ContactView,
    EntityCustomFieldValueView,
    EntityTypeUserView
} from '@api-proxies';
import { ModelBase } from './ModelBase';

export class Company extends ModelBase implements CompanyView {
    static fromInterface(dto: CompanyView): Company {
        const company = new Company();
        company.mapFromInterface(dto);
        return company;
    }

    organizationId: number | undefined;
    name: string | undefined;
    abbreviation: string | undefined;
    webSite: string | undefined;
    linkedin: string | undefined;
    accountId: number | undefined;
    accountName: string | undefined;
    createdByUserId: number | undefined;
    companyTypeId: number | undefined;
    companyTypeName: string | undefined;
    legalStatusId: number | undefined;
    legalStatusName: string | undefined;
    buildingName: string | undefined;
    line1: string | undefined;
    line2: string | undefined;
    zipCode: string | undefined;
    countryId: number | undefined;
    countryName: string | undefined;
    stateId: number | undefined;
    stateName: string | undefined;
    cityId: number | undefined;
    cityName: string | undefined;
    fullAddress: string | undefined;
    markets: string | undefined;
    organizationName: string | undefined;
    contactFirstName: string | undefined;
    contactLastName: string | undefined;
    contactFullName: string | undefined;
    contactPhone: string[] | undefined;
    contactId: number | undefined;
    mainOfficeId: number | undefined;
    isActive: boolean;
    buildingContacts: BuildingContactView[] | undefined;
    companyBuildings: CompanyBuildingView[] | undefined;
    buildings: BuildingView[] | undefined;
    companyMarkets: CompanyMarketView[] | undefined;
    contacts: ContactView[] | undefined;
    countryCode: string | undefined;
    stateCode: string | undefined;
    addressLines: string | undefined;
    customFieldValues: EntityCustomFieldValueView[] | undefined;
    companySalespersons: EntityTypeUserView[] | undefined;
    description: string | undefined;
    accountIsActive: boolean | undefined;
    buildingIsActive: boolean | undefined;
    contactIsActive: boolean | undefined;

    constructor() {
        super();
        this.organizationId = undefined;
        this.name = '';
        this.abbreviation = '';
        this.webSite = '';
        this.linkedin = '';
        this.accountId = undefined;
        this.accountName = '';
        this.companyTypeId = undefined;
        this.companyTypeName = '';
        this.legalStatusId = undefined;
        this.legalStatusName = '';
        this.buildingName = '';
        this.line1 = '';
        this.line2 = '';
        this.zipCode = '';
        this.countryId = undefined;
        this.countryName = '';
        this.stateId = undefined;
        this.stateName = '';
        this.cityId = undefined;
        this.cityName = '';
        this.fullAddress = '';
        this.markets = '';
        this.organizationName = '';
        this.contactFirstName = '';
        this.contactLastName = '';
        this.contactFullName = '';
        this.contactPhone = [];
        this.contactId = undefined;
        this.mainOfficeId = undefined;
        this.isActive = true;
        this.buildingContacts = [];
        this.companyBuildings = [];
        this.companyMarkets = [];
        this.contacts = [];
        this.customFieldValues = [];
        this.buildings = [];
        this.companySalespersons = undefined;
        this.description = '';
        this.accountIsActive = true;
        this.buildingIsActive = true;
        this.contactIsActive = true;
    }
}
